import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { POLKADOT_API_STATE_GARBAGE_COLLECTOR_UNSTABLE } from './GarbageCollector.js';
import { RecoilRoot } from 'recoil';
export const ApiIdContext = createContext(undefined);
export const RecoilStateContext = createContext({
    // @ts-expect-error
    queryState: () => {
        throw new Error('Missing context provider');
    },
    // @ts-expect-error
    deriveState: () => {
        throw new Error('Missing context provider');
    },
    // @ts-expect-error
    queryMultiState: () => {
        throw new Error('Missing context provider');
    },
});
export const PolkadotApiProvider = (props) => (_jsx(RecoilRoot, { override: false, children: _jsx(ApiIdContext.Provider, { value: props.apiId, children: _jsxs(RecoilStateContext.Provider, { value: { queryState: props.queryState, deriveState: props.deriveState, queryMultiState: props.queryMultiState }, children: [_jsx(POLKADOT_API_STATE_GARBAGE_COLLECTOR_UNSTABLE, {}), props.children] }) }) }));
export const PolkadotApiIdProvider = (props) => (_jsx(ApiIdContext.Provider, { value: props.id, children: props.children }));
export const usePolkadotApiId = () => useContext(ApiIdContext);
//# sourceMappingURL=Context.js.map